
import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Row, Container, Col } from 'react-bootstrap';
import './App.css';
import PaginaSobras from "./modulos/pagina-sobras/PaginaSobras";


function App() {


  return (
    <div id="wrapper ">
        <Routes>
          <Route exact path="/" element={<PaginaSobras />} />
          <Route exact path="/sobras-web" element={<PaginaSobras />} />
        </Routes>
      </div>
  );
}


export default App;
